function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbbCloseLight24 = function SvgAbbCloseLight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.01 7.1-1.09-1.09-4.91 4.9-4.91-4.9L6.01 7.1l4.9 4.91-4.9 4.91 1.09 1.09 4.91-4.89 4.91 4.89 1.09-1.09-4.89-4.91z",
    "data-name": "Final icons - Common",
    style: {
      fill: "#1f1f1f"
    }
  }));
};
export default SvgAbbCloseLight24;